import { FAMILY_KEY, PROGRAM_KEY } from "../../constants/common"

const steps = ['Download T&C Document', 'Submit Application for APS Review', 'Approved/ Rejected by APS', 'Unique Enphase Site ID provided', 'Application submitted for Enphase Review', 'Approved/ Rejected by Enphase']

const APPLICATIONSUBMITTED = 'Application_Submitted'
const APPLICATIONAPPROVED = 'Application_Approved'
const APPLICATIONREJECTED = 'Application_Rejected'
const SITESUBMITTED = 'Site_Submitted'
const SITEAPPROVED = 'Site_Approved'
const SITEREJECTED = 'Site_Rejected'

const contentAlignment = (key) => {
  switch (key) {
    case PROGRAM_KEY.PSEG_LI: {
      return ({
        LEFTGRIDCONTENT: ['site_id', 'first_name', 'last_name', 'address1', 'address2', 'city', 'state'],
        RIGHTGRIDCONTENT: ['zip', 'email_address', 'phone', 'kw_capacity_committed', 'electric_account_number', 'utility_meter_number']
      })
    }
    case FAMILY_KEY.CT_ESS: {
      return ({
        LEFTGRIDCONTENT: ['site_id', 'first_name', 'last_name', 'address1', 'address2', 'city', 'state', 'zip'],
        RIGHTGRIDCONTENT: ['email_address', 'phone', 'kw_capacity_committed', 'electric_account_number', 'utility_meter_number', 'pto', 'event_incentive_category']
      })
    }
  }
}

export {
  steps,
  APPLICATIONSUBMITTED,
  APPLICATIONAPPROVED,
  APPLICATIONREJECTED,
  SITESUBMITTED,
  SITEAPPROVED,
  SITEREJECTED,
  contentAlignment
}